export default __webpack_public_path__ + "static/media/email.e78adde3.svg";